import _ from 'lodash';

// curly brace syntax
_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;

// this would most likely be in a language file
const TEMPLATES_MAP = {
    email: 'Le courriel doit être valide.',
    minLength: 'Longueur minimale de {{min}} caractères.',
    required: 'Champs requis.',
    validateFromServer: '{{ message }}',
    sameAsPassword: 'Les mots de passe doivent être identiques.'
};

export const FormGroup = {
    props: {
        validations: {
            required: true,
            type: Object
        },
        serverErrors: {
            type: Array,
            default: []
        }
    },
    computed: {
        errors() {
            if (!this.invalid) {
                return [];
            }
            return Object.keys(this.validations.$params).reduce(
                (errors, validator) => {
                    if (!this.validations[validator]) {
                        const compiled = _.template(TEMPLATES_MAP[validator]);
                        errors.push(compiled(this.validations.$params[validator]));
                    }
                    return errors;
                },
                []
            );
        },
        invalid() {
            return (this.validations.$dirty && this.validations.$invalid) || this.serverErrors.length;
        }
    },

    template: `
        <div class="c-form_item" :class="{'is-invalid': invalid}">
            <slot/>
            <div v-for="error in errors" class="c-form_error" :key="error">{{error}}</div>
            <div v-for="error in serverErrors" class="c-form_error" :key="error">{{error}}</div>
        </div>
    `,
};

export default FormGroup
